import React, { useEffect, useState, useContext } from "react";

import {
  Button,
  IconButton,
  TextField,
  Modal,
  Backdrop,
  Fade,
  makeStyles,
} from "@material-ui/core";

import Edit from "../assets/Configuracoes/Icon material-edit@2x.png";
import addImg from "../assets/Configuracoes/Icon feather-plus@2x.png";
import ComputerIcon from "@material-ui/icons/Computer";
import X from "../assets/Configuracoes/X1.png";

import { SponsorContext } from "../context/Sponsorcontext";

export default function ModalParceiroM({ fileNome, nome, link, url, id, description }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [name, setName] = useState(nome ? nome : "");
  const [imageBase64, setImageBase64] = useState("");
  const [fileName, setFileName] = useState(fileNome ? fileNome : "");
  const [website, setWebsite] = useState(
    link === undefined ? "https://" : link
  );
  const [descriptionText, setDescriptionText] = useState(description || "");
  const [fileURL, setURL] = useState(url ? url : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const { addSponsor, editSponsor } = useContext(SponsorContext);

  const handleUpload = () => {
    const nameValue = String(name || "").trim();
    const websiteValue = String(website || "").trim();
    const descriptionValue = String(descriptionText || "").trim();
    
    const data = {
      name: nameValue,
      website: websiteValue,
      ...(descriptionValue && { description: descriptionValue }),
      ...(imageBase64 && { logo: imageBase64 })
    };
    
    console.log("Sponsor data:", { ...data, logoLength: imageBase64?.length });
    
    return data;
  };

  const handleInsert = async (e) => {
    e.preventDefault();
    if (!name || !name.trim()) {
      alert("Nome é obrigatório");
      return;
    }
    const data = handleUpload();
    handleClose();
    await addSponsor(data);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    if (!name || !name.trim()) {
      alert("Nome é obrigatório");
      return;
    }
    const data = handleUpload();
    await editSponsor(id, data);
  };

  const handleBtnChange = (e) => {
    setFileName(null);
    setURL(null);
    setImageBase64("");

    if (e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setFileName(selectedFile.name);
      setURL(URL.createObjectURL(selectedFile));
      
      // Convert to base64
      const reader = new FileReader();
      reader.onload = (event) => {
        setImageBase64(event.target.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  useEffect(() => {
    if (fileName) setButtonDisabled(false);
  }, [fileName]);

  const handleOpen = () => {
    setOpen(true);
    if (!fileURL) setButtonDisabled(true);

    if (id) {
      setName(nome);
      setFileName(fileNome);
      setURL(url);
      setWebsite(link);
      setDescriptionText(description || "");
    }
  };
  const handleClose = () => {
    setOpen(false);

    if (!id) {
      setName("");
      setFileName("");
      setURL("");
      setImageBase64("");
      setWebsite("https://");
      setDescriptionText("");
    }
  };

  return (
    <div>
      {id === undefined ? (
        <Button onClick={(e) => { e.stopPropagation(); handleOpen(); }}>
          <img src={addImg} alt="addImg" className={classes.editbuttom} />
        </Button>
      ) : (
        <Button onClick={handleOpen}>
          <img src={Edit} alt="Edit" className={classes.editbuttom} />
        </Button>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} onClick={(e) => e.stopPropagation()}>
            <div className={classes.close}>
              <Button onClick={handleClose}>
                <img src={X} alt="close" className={classes.closeButton} />
              </Button>
            </div>
            <form
              className={classes.form}
              onSubmit={id ? handleEdit : handleInsert}
            >
              <div className={classes.content}>
                <div className={classes.txtinput}>
                  <TextField
                    required
                    id="outlined-basic"
                    label="Nome"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    value={name}
                    onChange={({ target }) => setName(target.value)}
                    style={{ width: "100%" }}
                  />
                  <TextField
                    required
                    id="outlined-basic"
                    label="Website"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    value={website}
                    onChange={({ target }) => setWebsite(target.value)}
                    style={{ width: "100%" }}
                  />
                  <TextField
                    id="outlined-basic"
                    label="Descrição (opcional)"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    multiline
                    rows={2}
                    value={descriptionText}
                    onChange={({ target }) => setDescriptionText(target.value)}
                    style={{ width: "100%" }}
                  />
                  <TextField
                    id="outlined-read-only-input"
                    label="Imagem"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="outlined"
                    value={fileName}
                    onChange={({ target }) => setFileName(target.value)}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className={classes.uploader}>
                  <div style={{ height: "30px" }} />
                  <div className={classes.imgViewer}>
                    {fileURL && (
                      <>
                        <img src={fileURL} alt="" className={classes.img} />
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className={classes.uploadbutton}>
                    <label htmlFor="upload-btn">
                      <input
                        accept=".jpg, .jpeg, .png, .gif" // Mudanca para tentar aceitar imagens do tipo GIF
                        id="upload-btn"
                        type="file"
                        hidden
                        onChange={handleBtnChange}
                      />
                      <IconButton
                        className="btn-upload"
                        variant="contained"
                        component="span"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ComputerIcon style={{ color: "#707070" }} />
                      </IconButton>
                    </label>
                </div>

              <Button
                disabled={buttonDisabled}
                variant="contained"
                color="primary"
                className={classes.salvar}
                type="submit"
              >
                SALVAR
              </Button>
            </form>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    height: "620px",
    width: "320px",
    backgroundColor: theme.colors.white,
    boxShadow: "0px 4px 16px #00000030",
    borderRadius: "5px",
    flexDirection: "column",
    display: "flex",
    padding: "0 0 20px 0",
  },
  txtinput: {
    width: "85%",
    flexDirection: "column",
    gap: "20px",
    display: "flex",
    margin: "20px auto 0 auto",
  },
  editbuttom: {
    height: "24px",
    width: "24px",
  },
  savebuttom: {
    width: "120px",
    height: "46px",
    backgroundColor: theme.colors.darkBlue,
    color: theme.colors.white,
    font: "Karla,Regular",
    fontSize: "18px",
  },
  form: {
    height: "100%",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
    padding: "10px 0",
  },
  img: {
    width: "100%",
    maxWidth: "220px",
    maxHeight: "120px",
    objectFit: "cover",
  },
  salvar: {
    width: "120px",
    height: "46px",
    borderRadius: "4px",
    font: "Karla,Regular",
    fontSize: "18px",
  },
  close: {
    width: "100%",
    justifyContent: "flex-end",
    display: "flex",
  },
  closeButton: {
    height: "23px",
  },
  uploader: {
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "20px",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
    gap: "15px",
  },
}));
